import {Component, Input} from '@angular/core';
import {NgxSpinnerComponent, NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-spinner',
  imports: [
    NgxSpinnerComponent
  ],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  @Input() fullScreen: boolean = true;
  @Input() size: 'default' | 'small' | 'medium' | 'large' = 'medium';
  @Input() type: 'ball-scale-multiple' | 'ball-clip-rotate-pulse' = 'ball-scale-multiple';
  constructor(private spinner: NgxSpinnerService) { }

  show(): void {
    this.spinner.show();
  }

  hide(): void {
    this.spinner.hide();
  }
}
